export const messages = {
  title: {
    id: "no-plans-found.title",
    defaultMessage: "No plans found",
  },
};
